import classNames from 'classnames';
import type { FC, SyntheticEvent } from 'react';
import { Icon } from '../Icon/Icon';
import { getMessageClassNames } from './Message.styles';
import {
  type MessageProps,
  fromMessageToIconSize,
  fromMessageTypeToIconColor,
  fromMessageTypeToIconGlyph,
} from './Message.types';

export const Message: FC<MessageProps> = ({
  variant,
  size = 'default',
  type = 'plain',
  statusIcon = true,
  title,
  message,
  className,
  onRemove,
  dismissible,
  link,
  loading,
}) => {
  const handleRemoveClick = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();

    onRemove?.();
  };

  return (
    <div className={getMessageClassNames(variant, size, type, className)}>
      <div className='flex gap-3xs'>
        {statusIcon && (
          <Icon
            className={fromMessageTypeToIconColor[type]}
            glyph={fromMessageTypeToIconGlyph[type]}
            size={fromMessageToIconSize[size]}
            iconStyle='solid'
            loading={loading}
          />
        )}
        <div className='flex gap-1 flex-col items-start'>
          {title && (
            <div
              className={classNames(
                size === 'small' ? 'text-xs' : 'text-sm',
                'font-semibold',
              )}
            >
              {title}
            </div>
          )}
          {message && (
            <div
              className={classNames(
                'text-xs',
                !title && size === 'default' ? 'leading-5' : '',
              )}
            >
              {message}
            </div>
          )}
          {link}
        </div>
      </div>
      {dismissible && (
        <div className='min-w-5'>
          <Icon
            className={'cursor-pointer text-default'}
            iconStyle='solid'
            glyph='fa-xmark'
            size={fromMessageToIconSize[size]}
            onClick={handleRemoveClick}
            data-testid='remove-icon'
          />
        </div>
      )}
    </div>
  );
};
